import { render, staticRenderFns } from "./object-metric.vue?vue&type=template&id=e693e27a&"
import script from "./object-metric.vue?vue&type=script&lang=js&"
export * from "./object-metric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports